import React from "react";
import weddingvendor from "../Images/weddingvendor.png";
import { Button, Divider, Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { IoSendSharp } from "react-icons/io5";

export default function VendorForm() {
  return (
    <>
      <section className="home-page-app-download-con">
        <div className="container">
          <div className="home-page-app-download-main-con-w">
            <div className="row">
              <div className="col-12">
                <div className="home-page-app-download-main-div">
                  <div className="home-page-app-main-details-con">
                    <h3 className="text-dark">
                      Are You a Wedding Vendor? This Is Your Spot!
                    </h3>
                    <p style={{ color: "#808080" }}>
                      List your services, connect with clients, and grow your
                      business with Weddingz.adda.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <img
                  className="w-100 h-100"
                  style={{
                    maxWidth: 500,
                    objectFit: "cover",
                    margin: "10px 0",
                  }}
                  src={weddingvendor}
                />
              </div>
              <div className="col-md-5 d-flex align-items-start justify-content-center  flex-column">
                <h4 style={{ textAlign: "start", color: "#000" }}>
                  We Help to grow your business in Wedding industry
                </h4>
                <p style={{ textAlign: "start", color: "#808080" }}>
                  At Weddingz.adda, we offer a dedicated space for wedding
                  vendors like you to showcase your services, connect with
                  potential clients, and expand your reach in the ever-growing
                  wedding industry. Whether you're a venue owner, photographer,
                  makeup artist, or planner, our platform is built to put your
                  business in front of thousands of couples actively searching
                  for trusted vendors.
                </p>
                <p style={{ textAlign: "start", color: "#808080" }}>
                  We don’t just list your services — we help you grow. With
                  features like profile customization, client inquiries, and
                  promotional tools, Weddingz.adda gives you everything you need
                  to stand out in a competitive market. Join today and become
                  part of a vibrant network that’s redefining how weddings are
                  planned across the country.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Divider />
      <section>
        <div className="container">
          <h2 className="text-left">Request for list your business !</h2>
          <br />
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-6">
                <Form.Item>
                  <Input
                    style={{ height: 45, borderColor: "#800000" }}
                    placeholder="Business Name"
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item>
                  <Input
                    style={{ height: 45, borderColor: "#800000" }}
                    placeholder="Business Type"
                  />
                </Form.Item>
              </div>
              <div className="col-md-4">
                <Form.Item>
                  <Input
                    style={{ height: 45, borderColor: "#800000" }}
                    placeholder="Your Name"
                  />
                </Form.Item>
              </div>
              <div className="col-md-4">
                <Form.Item>
                  <Input
                    style={{ height: 45, borderColor: "#800000" }}
                    placeholder="Your Email"
                  />
                </Form.Item>
              </div>
              <div className="col-md-4">
                <Form.Item>
                  <Input
                    style={{ height: 45, borderColor: "#800000" }}
                    placeholder="Your Phone"
                  />
                </Form.Item>
              </div>
              <div className="col-12">
                <Form.Item>
                  <TextArea
                    style={{ borderColor: "#800000" }}
                    rows={7}
                    placeholder="Business Name"
                  />
                </Form.Item>
              </div>

              <div className="col-12">
                <Form.Item>
                  <Button style={{ background: "#800000", color: "#fff", height:45 }} icon={<IoSendSharp />}>
                    Submit Request
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
}
